// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"ccb13f6c","516":"4739ff8a","732":"11c1993b","879":"fd8acdae","977":"ca0562dd"}[chunkId] + ".chunk.js";
};